/**
 * Шкала кеглей интерфейса.
 *
 * В теме (`tokens.ts`) размеров шрифта нет — страницы ОСНОВЫ задают их числами
 * по месту. Новые экраны берут кегль отсюда, чтобы шкала оставалась короткой:
 * пять размеров на весь экран. Перенос в `OsnovaTheme` — отдельным шагом, когда
 * на шкалу перейдут и остальные страницы.
 */
export const fontSize = {
  /** Подписи, счётчики, метки колонок. */
  xs: '12px',
  /** Вторичный текст, строки таблиц на телефоне. */
  sm: '13px',
  /** Основной текст интерфейса, строки списков. */
  md: '14px',
  /** Заголовки панелей и диалогов. */
  lg: '16px',
  /** Заголовок окна. */
  xl: '18px',
} as const;

export const lineHeight = {
  tight: 1.25,
  base: 1.45,
} as const;
